import { provideStoreDevtools } from '@ngrx/store-devtools';
import { EnvironmentType } from '@ls/models-environment';

export const environment = {
  type: EnvironmentType.Development,
  lifewaveProxyApiUrl:
    'https://development.nowsite-internal-api.lifewave.com/proxy',
  lifewaveApiUrl: 'https://staging-nowsite.lifewave.com/api',
  translationsApiUrl:
    'https://development.translations.enrollment.lifewave.com',
  tokenexApiUrl:
    'https://development.nowsite-internal-api.lifewave.com/tokenex',
  tokenEx: {
    clientId: '3649316995937637',
  },
  providers: [
    provideStoreDevtools({
      maxAge: 25,
      autoPause: true,
      trace: true,
      traceLimit: 75,
    }),
  ],
};
